import { TFranchise } from '../types/franchiseManagement';

export const defaultSelectedFranchiseProfile: TFranchise = {
  id: 0,
  name: 'Profile',
  vat: '',
  vatIncluded: 0,
  taxableDeliveryFee: 0,
  vatRegistrationNumber: '',
  certificateUrl: '',
  certificateFilename: '',
  certificate: new File([], ''),
  currencyId: '',
  currencyCode: '',
  timezone: '',
  branches: [],
  is_default: 1,
};

export const defaultProfile = { id: '1', name: 'Default' };

export const franchiseToastErrorId: string = 'franchise-toast-error-id';
